let sessionCookieKey = ''

export function setSessionCookieKey(key: string) {
  sessionCookieKey = key
}

export function getSessionCookieKey() {
  return sessionCookieKey
}
